import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { ProductModel } from '@mmx/shared'

@Component({
  selector: 'mmx-products-selector-dialog-cmp',
  templateUrl: './products-selector-dialog.component.html',
  standalone: false,
})
export class ProductsSelectorDialogComponent {
  products: ProductModel[]
  selectedProducts: ProductModel[]

  constructor(
    public dialogRef: MatDialogRef<ProductsSelectorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.products = data.products || []
  }

  get selectAllLabel(): string {
    if (
      this.selectedProducts &&
      this.selectedProducts.length === this.products.length
    ) {
      return 'Deselect All'
    } else {
      return 'Select All'
    }
  }

  toggleSelectAll() {
    if (this.selectedProducts.length === this.products.length) {
      this.selectedProducts = []
    } else {
      this.selectedProducts = this.products.concat([])
    }
  }
}
